module.exports = __webpack_public_path__ + "img/Icon-ExpensesVendors.938b8db9.svg";